import { Box } from '@mui/material';
import SmallModal from '../../global/SmallModal';

interface Props {
  title?: string;
  src: string | null;
  open: boolean;
  onClose: () => void;
}

function IFrameModal({ src, title, open, onClose }: Props) {
  return (
    <SmallModal open={open && !!src} onClose={onClose} title={title}>
      {!!src && (
        <Box
          width="100%"
          height="100%"
          overflow="auto"
          display="flex"
          alignItems="start">
          <iframe
            src={src}
            style={{
              width: '100%',
              height: 'fit-content',
              border: 'none',
              minHeight: '70vh',
              flex: 1,
            }}
            title={title || 'Embedded content'}
          />
        </Box>
      )}
    </SmallModal>
  );
}

export default IFrameModal;
